export const AUTH_TOKEN_STORAGE_KEY = 'callcenter::authToken';
export const AUTH_USER_STORAGE_KEY = 'callcenter::authUser';

export const getStoredAuthToken = () => {
  try {
    return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const getStoredAuthUser = () => {
  try {
    const raw = localStorage.getItem(AUTH_USER_STORAGE_KEY);

    if (!raw) {
      return null;
    }

    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const persistAuthToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    } else {
      localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    }
  } catch {
    // no-op for environments without localStorage access
  }
};

export const persistAuthUser = (user) => {
  try {
    if (user) {
      localStorage.setItem(AUTH_USER_STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(AUTH_USER_STORAGE_KEY);
    }
  } catch {
    // no-op for environments without localStorage access
  }
};
